var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.9999 3L21.5262 19.5H2.47363L11.9999 3Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }